import { useQuery } from "@tanstack/react-query";
import {
	getSawBundlesByShift,
	type SawBundlesByShift,
} from "../repositories/sawBundlesRepository";

export const sawBundlesByShiftKey = ["sawQualityChecks", "byShift"] as const;

export const useSawBundlesByShift = (
	assetId: number,
	shiftId?: number | null,
) => {
	return useQuery<SawBundlesByShift, Error>({
		queryKey: [...sawBundlesByShiftKey, assetId, shiftId ?? "current"],
		queryFn: () => getSawBundlesByShift(assetId, shiftId),
		meta: {
			realtime: [
				"FAB.GetSawBundlesByShift",
				"FAB.GetSawQualityChecks",
				"FAB.GetSawQualityChecksReport",
				"FAB.GetRecentBundles",
			],
		},
		enabled: assetId > 0,
		staleTime: 5_000,
		refetchInterval: 10_000,
		refetchOnWindowFocus: true,
	});
};
